// extracted by mini-css-extract-plugin
export default {"permalinkReader":"styles-module__permalinkReader__src-labstep-web-components-ProtocolValue-PermaLinkReader-_R_mpm"};